var ReCaptchaInstance = (function () {
    function ReCaptchaInstance(siteKey, recaptcha) {
        this.siteKey = siteKey;
        this.recaptcha = recaptcha;
    }
    ReCaptchaInstance.prototype.execute = function (action) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.recaptcha.execute(_this.siteKey, { action: action }).then(resolve, reject);
        });
    };
    ReCaptchaInstance.prototype.hideBadge = function () {
        var badges = this.findBadges();
        badges.forEach(function (badge) {
            badge.style.display = 'none';
        });
    };
    ReCaptchaInstance.prototype.showBadge = function () {
        var badges = this.findBadges();
        badges.forEach(function (badge) {
            badge.style.display = 'block';
        });
    };
    ReCaptchaInstance.prototype.findBadges = function () {
        var foundElements = Array.from(document.getElementsByClassName('grecaptcha-badge'));
        return foundElements.filter(function (value) {
            return value instanceof HTMLElement;
        }).map(function (value) { return value; });
    };
    return ReCaptchaInstance;
}());
export { ReCaptchaInstance };
